import { Box, Button, Chip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IBusinessView } from '../../shared/services';

interface OnboardingBannerProps {
  business: IBusinessView;
  refetch: () => void;
}

export const OnboardingBanner: React.FC<OnboardingBannerProps> = ({ business }) => {
  const navigate = useNavigate();

  const stepsCompleted = Math.min(business.onboardingStep ?? 0, 6);

  return (
    <Box
      sx={{
        background: (theme) =>
          theme.palette.mode === 'dark'
            ? 'linear-gradient(135deg, #1a237e 0%, #311b92 100%)'
            : 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)',
        borderRadius: 2,
        px: { xs: 2, sm: 3 },
        py: 2,
        mx: { xs: 1, sm: 2 },
        mb: 2,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: { xs: 1.5, sm: 2 },
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box display='flex' alignItems='center' gap={1} mb={0.5}>
          <Typography variant='h6' fontWeight={700} sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }}>
            🚀 Continue seu cadastro!
          </Typography>
          <Chip
            label={`${stepsCompleted} de 6`}
            size='small'
            color='primary'
            sx={{ fontWeight: 600 }}
          />
        </Box>
        <Typography variant='body2' color='text.secondary'>
          Complete o cadastro para ativar sua página pública e começar a receber agendamentos online.
        </Typography>
      </Box>

      <Box display='flex' gap={1} flexWrap='wrap'>
        <Button
          variant='contained'
          size='small'
          onClick={() => navigate('/onboarding', { state: { businessId: business.id } })}
        >
          Continuar Onboarding →
        </Button>
      </Box>
    </Box>
  );
};
